import type { ManagementMode } from '~/types/knowledge';

// One visual contract for management authority across Graph collections and details.
export function SystemManagedBadge({ className = '', mode = 'system_required' }: { className?: string; mode?: ManagementMode }) {
  const derived = mode === 'system_derived';
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${derived ? 'bg-sky-50 text-sky-700 dark:bg-sky-950/50 dark:text-sky-300' : 'bg-violet-50 text-violet-700 dark:bg-violet-950/50 dark:text-violet-300'} ${className}`}>
      {derived ? 'Entity Box suggested' : 'Entity Box managed'}
    </span>
  );
}
